import ArrowForwardIcon from '../../assets/icons/arrow_forward.svg?react';
import { cn } from '../../utils/classNames';
import Tooltip from './Tooltip';
import XLink from '../common/XLink';

const arrowClasses = 'ml-auto h-action-arrow-h w-action-arrow-w flex-none';

// filled variant of the outlined action button — inverted colors using ! to override the variant
const finalizeColorClasses = 'bg-action! text-white! visited:text-white! hover:bg-action-active! hover:text-white!';

const FinalizeCaseLink = ({ caseId }) => (
    <Tooltip title="Confirm the lifecare plan is ready to be delivered" placement="top">
        <XLink
            to={`/case/finalize/${caseId}`}
            variant="actionOutline"
            className={cn('visible opacity-100', finalizeColorClasses)}
        >
            <span>Finalize</span>
            <ArrowForwardIcon className={cn(arrowClasses, '[&_path]:fill-white!')} />
        </XLink>
    </Tooltip>
);

export default FinalizeCaseLink;
